
import {createRouter} from "vue-router/dist/vue-router";
import { createWebHistory } from 'vue-router'

import {createWebHashHistory} from "vue-router";
import layout from "@/layout/Layout";
import left from "@/layout/Left";
import login from "@/components/adminView/Login";
import webLogin from "@/components/WebLogin.vue";
import webPlacebet from "@/components/WebPlacebet.vue";
import webIndex from "@/components/WebIndex";
import lotteryRecordList from "@/components/LotteryRecordList";
import czIntroduce from "@/components/CzIntroduce";
import companyProfile from "@/components/CompanyProfile";
import newsNotice from "@/components/NewsNotice";

import lotteryRecordBackList from "@/components/adminView/LotteryRecordList";
import sysUser from "@/components/adminView/SysUser";
import newsNoticeInfo from "@/components/NewsNoticeInfo";
import mobileHome from "@/components/MobileHome";
import mobileRecordList from "@/components/MobileRecordList";
const routes = [
    {
        path:'/',
        name:'webIndex',
        component:webIndex
    },
    {
        path:'/lotteryRecordList',
        name:'lotteryRecordList',
        component:lotteryRecordList
    },
    {
        path:'/czIntroduce',
        name:'czIntroduce',
        component:czIntroduce
    },
    {
        path:'/companyProfile',
        name:'companyProfile',
        component:companyProfile
    },
    {
        path:'/newsNotice',
        name:'newsNotice',
        component:newsNotice
    },
    {
        path:'/newsNoticeInfo',
        name:'newsNoticeInfo',
        component:newsNoticeInfo,
    },
    {
        path:'/mobileHome',
        name:'mobileHome',
        component:mobileHome,
    },
    {
        path:'/mobileRecordList',
        name:'mobileRecordList',
        component:mobileRecordList,
    },
    {
        path:'/login',
        name:'login',
        component:login
    },
    {
        path:'/weblogin',
        name:'webLogin',
        component:webLogin
    },
    {
        path:'/webPlacebet',
        name:'webPlacebet',
        component:webPlacebet
    },
    {
        path:'/backWeb',
        name:'layout',
        component:layout,
        children: [
            {
                path:'/lotteryRecordBackList',
                name:'lotteryRecordBackList',
                component:lotteryRecordBackList
            },
            {
                path:'/sysUser',
                name:'sysUser',
                component:sysUser
            }
        ]
    },
    {
        path:'/left',
        name:'left',
        component:left
    }





]

const router = new  createRouter({
    history:createWebHistory(),
    routes
})
export default router